const now = Date.now()
const daysAgo = (n, hours = 0) => new Date(now - n * 86400000 - hours * 3600000).toISOString()

export const CARD_COLUMNS = [
  { id: 'inspiration', label: '灵感', en: 'SPARKS', hint: '先记下来，不必完整', color: '#c9a24d' },
  { id: 'draft', label: '草稿', en: 'DRAFTS', hint: '让场景先长出来', color: '#7d9a82' },
  { id: 'polish', label: '打磨', en: 'REVISIONS', hint: '删掉多余，留下呼吸', color: '#c1785e' },
  { id: 'done', label: '落定', en: 'SETTLED', hint: '这一页可以交给读者了', color: '#677d98' },
]

export const CARD_COLORS = {
  sand: '#f2e6cd',
  rose: '#f0ddd7',
  sage: '#e2e9dd',
  sky: '#dfe9eb',
  butter: '#f3eccf',
  lilac: '#e8e2e8',
  paper: '#fbf8f1',
}

export const COVER_THEMES = [
  { id: 'forest', label: '海松', swatch: '#24382e' },
  { id: 'ochre', label: '麦田', swatch: '#b47b3e' },
  { id: 'navy', label: '夜航', swatch: '#2d3d55' },
  { id: 'clay', label: '陶土', swatch: '#9d5844' },
]

export const PROJECT_TYPES = ['长篇小说', '短篇集', '写作研究', '私人手记', '随笔']

const tideCards = [
  {
    id: 'tide-01',
    title: '潮声在凌晨三点',
    summary: '林遥回到潮汐镇的第一夜，捡到一只塞着蓝色信纸的玻璃瓶。',
    content: '凌晨三点，潮水把一只空玻璃瓶推上岸。\n\n林遥蹲下去，瓶口塞着一小卷发黄的纸。她认得那种蓝色墨水——母亲失踪以前，用它写坏了整整十二本航海日志。\n\n远处的灯塔熄着。海面很平，像有人把一整片黑夜仔细熨过。',
    column: 'draft',
    act: '第一幕 · 潮声',
    tags: ['开篇', '归乡'],
    color: 'sand',
    graph: { x: 0.14, y: 0.2 },
    notes: '“熨过”这个动作很好，保留。',
    createdAt: daysAgo(24),
    updatedAt: daysAgo(2, 3),
  },
  {
    id: 'tide-02',
    title: '灯塔守望者',
    summary: '父亲的最后一次值班记录停在七月十六日，只有四个字：她来过了。',
    content: '父亲守了十九年灯塔，最后一次值班记录停在七月十六日。那一页没有天气，也没有潮位，只有四个字：她来过了。\n\n林遥把那一页翻过来，纸背有铅笔写下的数字，被橡皮擦得很淡。\n\n491。',
    column: 'draft',
    act: '第一幕 · 潮声',
    tags: ['父亲', '线索'],
    color: 'sage',
    graph: { x: 0.36, y: 0.15 },
    notes: '',
    createdAt: daysAgo(23),
    updatedAt: daysAgo(3),
  },
  {
    id: 'tide-03',
    title: '缺了一页的航海日志',
    summary: '七月十六日被整齐撕走，只剩订口处一道锯齿。',
    content: '父亲的航海日志缺了一页。撕口很整齐，像用尺子比着裁下来的。\n\n林遥记得母亲不喜欢裁纸刀。她总说，纸是有纹理的，逆着撕会疼。\n\n可那一页确实不见了。连潮位表都从十六日直接跳到了十八日。',
    column: 'inspiration',
    act: '第一幕 · 潮声',
    tags: ['谜团', '手稿'],
    color: 'sky',
    graph: { x: 0.16, y: 0.53 },
    notes: '',
    createdAt: daysAgo(22),
    updatedAt: daysAgo(4),
  },
  {
    id: 'tide-04',
    title: '盐与旧唱片',
    summary: '母亲的旧唱片里录着一段海声，和一个陌生男人的口哨。',
    content: '唱片转到第二面，会发出细小的、像海水漫过脚背的声音。\n\n林遥把耳朵贴近音箱。海声里夹着一段口哨，调子不对，像吹的人忘了后半句。\n\n她忽然想起，母亲从不吹口哨。',
    column: 'polish',
    act: '第二幕 · 退潮',
    tags: ['声音', '母亲'],
    color: 'rose',
    graph: { x: 0.37, y: 0.52 },
    notes: '',
    createdAt: daysAgo(18),
    updatedAt: daysAgo(2, 8),
  },
  {
    id: 'tide-05',
    title: '母亲的口琴',
    summary: '口琴藏在米缸下面，铜片已经锈住，却还能吹出一个音。',
    content: '母亲总说，口琴要等潮水退下去再吹，既使海面看起来很平静。\n\n林遥把它从米缸下面摸出来。铜片锈住了大半，她试着吹了一下，只有一个低低的音，像很远的地方有人应了一声。\n\n窗外的雨忽然大了。',
    column: 'draft',
    act: '第二幕 · 退潮',
    tags: ['母亲', '物件'],
    color: 'butter',
    graph: { x: 0.55, y: 0.19 },
    notes: '',
    createdAt: daysAgo(17),
    updatedAt: daysAgo(1, 5),
  },
  {
    id: 'tide-06',
    title: '失踪的第七天',
    summary: '第七天，灯塔没有亮。无线电静默了整整七分钟。',
    content: '第七天，灯塔没有亮。潮汐镇的无线电静默了整整七分钟。\n\n那是七月十六日之后，母亲唯一可能靠岸的窗口。\n\n镇长说搜救已经结束。林遥没说话，只把那七分钟记在本子上，画了一道很轻的线。',
    column: 'inspiration',
    act: '第二幕 · 退潮',
    tags: ['失踪', '时间'],
    color: 'lilac',
    graph: { x: 0.56, y: 0.6 },
    notes: '',
    createdAt: daysAgo(16),
    updatedAt: daysAgo(5),
  },
  {
    id: 'tide-07',
    title: '雨夜渡轮',
    summary: '最后一班渡轮在雨里晚点四十分钟，船上多了一个没有行李的乘客。',
    content: '最后一班渡轮晚点了四十分钟。甲板上挤着回家的人，雨衣滴下来的水在脚边汇成细流。\n\n林遥站在船尾，看见岸上的灯塔亮了一下，又灭了。\n\n有人在身后问：小姐，你的票呢？\n\n她回过头。雨点打在舷窗上，像有人用指甲轻轻敲门，，又很快收回去。',
    column: 'polish',
    act: '第二幕 · 退潮',
    tags: ['雨夜', '悬疑'],
    color: 'sky',
    graph: { x: 0.34, y: 0.8 },
    notes: '',
    createdAt: daysAgo(15),
    updatedAt: daysAgo(1, 2),
  },
  {
    id: 'tide-08',
    title: '灯塔熄灭之前',
    summary: '七月十六日之后，会有整整七分钟的无光时刻。',
    content: '灯塔的光要在第三幕熄灭。林遥算过，七月十六日之后，潮汐镇会有整整七分钟的无光时刻。\n\n那是母亲唯一可能靠岸的窗口。\n\n她把计算写在旧日历背面，每一个数字都描了两遍，像怕它自己跑掉。',
    column: 'inspiration',
    act: '第二幕 · 退潮',
    tags: ['时间', '母亲'],
    color: 'sand',
    graph: { x: 0.71, y: 0.36 },
    notes: '',
    createdAt: daysAgo(13),
    updatedAt: daysAgo(4),
  },
  {
    id: 'tide-09',
    title: '退潮后的房间',
    summary: '母亲房间的墙纸下，藏着一张手绘的潮汐图。',
    content: '退潮以后，母亲房间里有股潮湿的石灰味。\n\n林遥撕开卷边的墙纸，里面不是砖，是一整面手绘的潮汐图。蓝色线条绕过礁石、暗沙和废弃的码头，最后停在一座没有名字的小岛。\n\n图角写着一行小字：等水最低的时候走。',
    column: 'draft',
    act: '第三幕 · 归来',
    tags: ['空间', '秘密'],
    color: 'rose',
    graph: { x: 0.82, y: 0.66 },
    notes: '',
    createdAt: daysAgo(12),
    updatedAt: daysAgo(1, 4),
  },
  {
    id: 'tide-10',
    title: '潮水带回的人',
    summary: '失踪三年后，母亲在一个没有月亮的夜里回来了。',
    content: '母亲是在凌晨三点回来的。\n\n她浑身湿透，鞋里灌着沙，站在门口像一段从海底捞上来的木头。林遥没有开灯，只看见她手里攥着那只玻璃瓶。\n\n瓶子里没有信。是一小卷湿掉的蓝线，线头还在滴水。\n\n母亲说：别问。先把窗关上。',
    column: 'done',
    act: '第三幕 · 归来',
    tags: ['归来', '转折'],
    color: 'sage',
    graph: { x: 0.61, y: 0.83 },
    notes: '',
    createdAt: daysAgo(10),
    updatedAt: daysAgo(0, 6),
  },
  {
    id: 'tide-11',
    title: '给妹妹的最后一页',
    summary: '林遥写给妹妹的信停在半句，像潮水退到一半。',
    content: '如果你读到这封信，替我去看看退潮后的港。看看那块写着“禁止靠近”的牌子后面，是不是还停着那艘白色的船。\n\n还有，别相信父亲说的——\n\n信到这里断了。',
    column: 'inspiration',
    act: '第三幕 · 归来',
    tags: ['信', '兄妹'],
    color: 'paper',
    graph: { x: 0.87, y: 0.48 },
    notes: '',
    createdAt: daysAgo(9),
    updatedAt: daysAgo(2),
  },
  {
    id: 'tide-12',
    title: '尾声 · 白鸟',
    summary: '三年后的清晨，一只白鸟落在熄灭的灯塔上。',
    content: '三年后的清晨，灯塔的灯罩里积了一层薄薄的盐。\n\n林遥爬上塔顶时，一只白鸟正落在栏杆上。它不怕人，歪着头看了她一会儿，然后朝海面飞去。\n\n潮水正在退。她忽然想起母亲说过，涨潮带走的东西，退潮不一定还回来。\n\n但有些声音会。',
    column: 'done',
    act: '第三幕 · 归来',
    tags: ['结尾', '海'],
    color: 'sky',
    graph: { x: 0.88, y: 0.16 },
    notes: '',
    createdAt: daysAgo(7),
    updatedAt: daysAgo(0, 2),
  },
]

const tideConnections = [
  { id: 'tide-link-01', source: 'tide-01', target: 'tide-02', label: '视角' },
  { id: 'tide-link-02', source: 'tide-01', target: 'tide-04', label: '声音母题' },
  { id: 'tide-link-03', source: 'tide-02', target: 'tide-03', label: '日志' },
  { id: 'tide-link-04', source: 'tide-04', target: 'tide-05', label: '母亲' },
  { id: 'tide-link-05', source: 'tide-01', target: 'tide-07', label: '雨夜' },
  { id: 'tide-link-06', source: 'tide-07', target: 'tide-09', label: '线索' },
  { id: 'tide-link-07', source: 'tide-09', target: 'tide-10', label: '回收' },
  { id: 'tide-link-08', source: 'tide-10', target: 'tide-11', label: '亲缘' },
  { id: 'tide-link-09', source: 'tide-05', target: 'tide-10', label: '口琴' },
  { id: 'tide-link-10', source: 'tide-06', target: 'tide-08', label: '重合线索' },
]

const cityCards = [
  {
    id: 'city-01',
    title: '便利店凌晨两点的关东煮',
    summary: '夜班护士、代驾司机和刚下播的主播，在同一口锅里捞萝卜。',
    content: '凌晨两点，便利店的关东煮开始浮起一层薄薄的油光。\n\n穿拖鞋的男人买了一串鱼丸，站在门口吃完，把竹签丢进垃圾桶时迟疑了一下，又捡起来，放进了可回收那一格。\n\n收银台后的女孩没有抬头。她正在看一本卷了边的《夜航西飞》。',
    column: 'draft',
    act: '夜行 · 便利店',
    tags: ['夜班', '陌生人'],
    color: 'butter',
    graph: { x: 0.2, y: 0.26 },
    notes: '',
    createdAt: daysAgo(14),
    updatedAt: daysAgo(1),
  },
  {
    id: 'city-02',
    title: '天桥下的修鞋摊',
    summary: '老人只修左脚鞋，他说右脚的问题都得自己走。',
    content: '修鞋摊在天桥第三个桥墩下面，一把伞，一盏充电灯，一块写着“只修左脚”的纸板。\n\n我问为什么。老人说，右脚的问题都得自己走。\n\n他把我的鞋翻过来，用锥子挑开开胶的地方，动作很轻，像在拆一封旧信。',
    column: 'draft',
    act: '夜行 · 天桥',
    tags: ['手艺', '对话'],
    color: 'sage',
    graph: { x: 0.47, y: 0.19 },
    notes: '',
    createdAt: daysAgo(12),
    updatedAt: daysAgo(2),
  },
  {
    id: 'city-03',
    title: '地铁末班车里的合唱',
    summary: '末班车经过江底时，整节车厢跟着一句哼唱起来。',
    content: '末班车经过江底时，车厢里有人先哼了一句。\n\n调子很旧，像九十年代的电视剧片尾曲。后来整节车厢都跟着唱起来，没有人知道歌名，也没有人觉得奇怪。\n\n列车冲上地面，歌声停了。窗外下雨了。',
    column: 'polish',
    act: '夜行 · 江底',
    tags: ['声音', '人群'],
    color: 'sky',
    graph: { x: 0.73, y: 0.41 },
    notes: '',
    createdAt: daysAgo(11),
    updatedAt: daysAgo(1, 6),
  },
  {
    id: 'city-04',
    title: '雨停之后，霓虹还亮着',
    summary: '凌晨四点的街口，所有招牌都像在等人。',
    content: '雨停之后，霓虹还亮着。\n\n红绿灯在没有车的十字路口重新数了一遍秒。卖豆浆的推车从巷子里出来，轮子压过积水，把整条街的灯影碾碎又拼好。\n\n城市最诚实的时候，是它以为没有人看见的时候。',
    column: 'done',
    act: '夜行 · 街口',
    tags: ['城市', '结尾'],
    color: 'rose',
    graph: { x: 0.52, y: 0.7 },
    notes: '',
    createdAt: daysAgo(10),
    updatedAt: daysAgo(0, 5),
  },
  {
    id: 'city-05',
    title: '早餐铺的第一笼蒸汽',
    summary: '第一笼包子出屉时，天还没有完全亮。',
    content: '早餐铺的第一笼蒸汽从卷帘门里涌出来，把路灯照得毛茸茸的。\n\n老板娘把包子一个个码在纱布上，动作快得像在弹一首无声的曲子。她男人在后面磨豆浆，石磨转得很慢。\n\n这条街的一天，总是从比别人早的黑暗里开始。',
    column: 'inspiration',
    act: '夜行 · 清晨',
    tags: ['清晨', '劳动'],
    color: 'sand',
    graph: { x: 0.25, y: 0.64 },
    notes: '',
    createdAt: daysAgo(8),
    updatedAt: daysAgo(3),
  },
]

const cityConnections = [
  { id: 'city-link-01', source: 'city-01', target: 'city-04', label: '夜归' },
  { id: 'city-link-02', source: 'city-02', target: 'city-05', label: '手艺人' },
  { id: 'city-link-03', source: 'city-03', target: 'city-04', label: '城市声音' },
]

const craftCards = [
  {
    id: 'craft-01',
    title: '好故事的七个开场',
    summary: '开场不必解释世界，只需要让一个具体的人想要一件具体的东西。',
    content: '不要去写“那是一个风雨交加的夜晚”。\n\n要写：她把最后一枚硬币投进电话机，听见那头的人先挂了。\n\n开场要做的事只有三件：让人物想要什么，让阻碍出现，让读者产生一个必须读下去的问题。',
    column: 'done',
    act: '方法 · 开场',
    tags: ['结构', '开场'],
    color: 'sage',
    graph: { x: 0.18, y: 0.22 },
    notes: '把“硬币”换成一个与故事世界有关的物件。',
    createdAt: daysAgo(40),
    updatedAt: daysAgo(2),
  },
  {
    id: 'craft-02',
    title: '人物欲望清单',
    summary: '人物想要的东西，和他真正需要的东西，必须不是同一件。',
    content: '想要的是外部目标：找回母亲、赢下比赛、拿到那笔钱。\n\n需要的是内部缺口：被原谅、被看见、承认自己也会害怕。\n\n好的故事让这两个答案在最后一刻同时抵达，又互相错过半步。',
    column: 'polish',
    act: '方法 · 人物',
    tags: ['人物', '欲望'],
    color: 'rose',
    graph: { x: 0.45, y: 0.2 },
    notes: '',
    createdAt: daysAgo(38),
    updatedAt: daysAgo(1),
  },
  {
    id: 'craft-03',
    title: '对话中的潜台词',
    summary: '人们很少直接说出自己真正想说的那句话。',
    content: '让角色谈论天气、账单、一碗面，而不是谈论爱和恐惧。\n\n潜台词不是把真实意图藏起来，而是让它在句子的缝里漏出来。读者听见的是“你吃了吗”，看见的是“你还在生我的气吗”。',
    column: 'draft',
    act: '方法 · 对话',
    tags: ['对话', '潜台词'],
    color: 'butter',
    graph: { x: 0.72, y: 0.38 },
    notes: '',
    createdAt: daysAgo(33),
    updatedAt: daysAgo(4),
  },
  {
    id: 'craft-04',
    title: '结尾的余震',
    summary: '结尾不是把坑填平，而是让读者在合上书之后还听见一点声音。',
    content: '解释清楚每一件事，常常是结尾最乏味的选择。\n\n留白不是偷懒。它需要前面的因果足够扎实，扎实到读者愿意自己走完最后一步。\n\n尾声里最好的动作，应该与开场形成回声，但不是原路返回。',
    column: 'inspiration',
    act: '方法 · 结尾',
    tags: ['结尾', '留白'],
    color: 'sky',
    graph: { x: 0.4, y: 0.67 },
    notes: '',
    createdAt: daysAgo(30),
    updatedAt: daysAgo(3),
  },
  {
    id: 'craft-05',
    title: '叙事节奏：快与慢',
    summary: '紧张感来自省略，情感来自停留。',
    content: '动作场面用短句，省略过程，只留下结果。\n\n情感场景反而要慢：让角色多做一件小事，让沉默比对话更长。\n\n节奏不是一直往前推。好的叙事知道什么时候应该停下来，让读者看见一片叶子的影子。',
    column: 'polish',
    act: '方法 · 节奏',
    tags: ['节奏', '场景'],
    color: 'lilac',
    graph: { x: 0.75, y: 0.7 },
    notes: '',
    createdAt: daysAgo(28),
    updatedAt: daysAgo(2, 4),
  },
]

const craftConnections = [
  { id: 'craft-link-01', source: 'craft-01', target: 'craft-02', label: '人物弧光' },
  { id: 'craft-link-02', source: 'craft-02', target: 'craft-03', label: '欲望外化' },
  { id: 'craft-link-03', source: 'craft-04', target: 'craft-05', label: '结尾节奏' },
]

const letterCards = [
  {
    id: 'letter-01',
    title: '写给十二月',
    summary: '在冬天来临之前，我想先把这一年好好叠起来。',
    content: '十二月尚未到来，我已经开始想念它。\n\n想念玻璃窗上的白雾，想念热水袋，想念那些需要在清晨多花五分钟穿好的衣服。\n\n今年我学会了一件事：有些告别不必说出口，只要把灯关掉，门带上，就可以了。',
    column: 'draft',
    act: '冬 · 来处',
    tags: ['冬天', '总结'],
    color: 'paper',
    graph: { x: 0.25, y: 0.3 },
    notes: '',
    createdAt: daysAgo(20),
    updatedAt: daysAgo(1),
  },
  {
    id: 'letter-02',
    title: '雪落在旧站台',
    summary: '那年我们都没有带伞，却谁也没有先走。',
    content: '雪落在旧站台上，像一张被反复擦过的白纸。\n\n她说，车还有十二分钟。我说，那够抽一根烟了。其实我们都不抽烟。我们只是需要十二分钟，把一句已经太晚说的话在嘴里捂热。\n\n车进站时，雪忽然大了。',
    column: 'polish',
    act: '冬 · 站台',
    tags: ['雪', '告别'],
    color: 'sky',
    graph: { x: 0.65, y: 0.28 },
    notes: '',
    createdAt: daysAgo(17),
    updatedAt: daysAgo(2),
  },
  {
    id: 'letter-03',
    title: '未寄出的第三封信',
    summary: '我把写给你的信按冬天编号，第三封一直没有封口。',
    content: '第一封写在下雪那天，第二封写在雪化之后。第三封没有日期。\n\n信纸换过三次，称呼却一直是同一个。写到一半，我总忍不住去看窗外。好像只要那棵树还在，你就还没有走远。',
    column: 'inspiration',
    act: '冬 · 未寄',
    tags: ['信', '未寄出'],
    color: 'rose',
    graph: { x: 0.46, y: 0.66 },
    notes: '',
    createdAt: daysAgo(15),
    updatedAt: daysAgo(4),
  },
]

const letterConnections = [
  { id: 'letter-link-01', source: 'letter-01', target: 'letter-03', label: '冬天' },
  { id: 'letter-link-02', source: 'letter-02', target: 'letter-03', label: '未说出口' },
]

export const SEED_PROJECTS = [
  {
    id: 'tide',
    title: '潮汐之间',
    subtitle: '一部关于失踪、灯塔与母女之间的海岸线小说',
    type: '长篇小说',
    theme: 'forest',
    description: '母亲在台风夜失踪，林遥回到潮汐镇整理灯塔。她在父亲的旧日志、盐蚀的唱片和十二封未寄出的信里，拼出一条只有退潮时才会出现的路。',
    goalWords: 3600,
    createdAt: daysAgo(26),
    updatedAt: daysAgo(0, 6),
    cards: tideCards,
    connections: tideConnections,
  },
  {
    id: 'city',
    title: '城市微光',
    subtitle: '十二个关于城市夜归人的短篇',
    type: '短篇集',
    theme: 'ochre',
    description: '凌晨两点的便利店、天桥下的修鞋摊、最后一班地铁。记录那些天亮以后就消失的人。',
    goalWords: 2400,
    createdAt: daysAgo(16),
    updatedAt: daysAgo(1),
    cards: cityCards,
    connections: cityConnections,
  },
  {
    id: 'craft',
    title: '故事采集器',
    subtitle: '写作方法、拆解与素材库',
    type: '写作研究',
    theme: 'navy',
    description: '把读到的、想到的、写坏的，都收进这个本子里。写给下一个正在开场的自己。',
    goalWords: 5000,
    createdAt: daysAgo(42),
    updatedAt: daysAgo(2),
    cards: craftCards,
    connections: craftConnections,
  },
  {
    id: 'letters',
    title: '一封寄往冬天的信',
    subtitle: '一些没有寄出的冬天',
    type: '私人手记',
    theme: 'clay',
    description: '写给十二月，写给旧站台，写给一直没有封口的第三封信。',
    goalWords: 1800,
    createdAt: daysAgo(21),
    updatedAt: daysAgo(3),
    cards: letterCards,
    connections: letterConnections,
  },
]
